import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/massai1.jpeg";
import image2 from "./images/massai2.jpeg";
import image3 from "./images/massai3.jpeg" ;
import image4 from "./images/massai4.jpeg" ;
import image5 from "./images/massai5.jpeg";



const Massai = () => {
    const images = [image1,image5,image2, image3, image4];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">MASSAI 2025</h2>
        <span className="section__subtitle">First place winner🥇</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🏆 Winner of two awards at MASSAI 2025 — 🥇 <strong>Best Poster</strong> and 📡 <strong>Best AI in Communications & Connectivity</strong> — for <strong>SinistrIA</strong>, an AI-powered solution automating insurance claims processing. 🤖
                    </p>
                    <p className='redRadio__text'>
                        💡 The project uses computer vision and intelligent workflow automation to streamline post-accident procedures, enhance decision-making, and reduce fraud.
                    </p>
                    <p className='redRadio__text'>
                        🌍 Recognized for its innovation and real-world impact in the <strong>InsurTech</strong> domain.
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Massai;
